import React from "react";
import { Tabs, Badge } from "antd";
import OncoMed from "./OncoMed";
import OncoFinished from "./OncoFinished";
import { useGetArizaNotFinishedQuery } from "../../redux/onco/onco";

function OncoAdmin() {
  const { data } = useGetArizaNotFinishedQuery();

  return (
    <div className="oncoAdmin">
      <Tabs
        defaultActiveKey="1"
        // onChange={onChange}
        items={[
          {
            label: <Badge count={data?.list?.length}>Yangi arizalar</Badge>,
            key: "1",
            children: <OncoMed />,
          },
          {
            label: `Bajarilgan arizalar`,
            key: "2",
            children: <OncoFinished />,
          },
        ]}
      />
    </div>
  );
}

export default OncoAdmin;
